import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CompanyState } from './company.reducer';

import { Company } from '@modules/core/models/company';
import { Thumb } from '@modules/core/models/company/image';

export const selectCompanyState = createFeatureSelector<CompanyState>('company');

export const selectCompany = createSelector(selectCompanyState, (s) => s.entity);

export const selectCompanyTheme = createSelector(selectCompanyState, (s) => s.entity?.themeName);

export const selectSocialMedia = createSelector(selectCompanyState, (s) => {
  const array = [];
  const keySting = 'socialMedia';

  for (const [key, value] of Object.entries(s.entity as Company)) {
    if (key.includes(keySting) && value) {
      const type = key.replace(keySting, '').toLowerCase();
      array.push({ type, link: value });
    }
  }

  return array;
});

export const selectCompanyLogoUrl = createSelector(selectCompanyState, (s) => {
  return (s.entity?.image?.thumbs.find((item) => item.size === 'original') as Thumb)?.url;
});

export const selectCompanyUuid = createSelector(selectCompanyState, (s) => s.entity?.uuid as string);

export const selectIsBookingEnabled = createSelector(selectCompanyState, (s) => s.entity?.bookingEnabled);

export const selectServicesPerBooking = createSelector(
  selectCompanyState,
  (s) => s.entity?.bookingSettings.servicesPerBooking
);

export const selectReminderFrequencyOfNotification = createSelector(
  selectCompanyState,
  (s) => s.entity?.bookingSettings.reminderFrequencyOfNotification
);

export const selectCompanyName = createSelector(selectCompanyState, (s) => s.entity?.name);

export const selectCompanyLocale = createSelector(selectCompanyState, (s) => s.entity?.locale);

export const selectIsSelfOrderingEnabled = createSelector(selectCompanyState, (s) => s.entity?.selfOrderingEnabled);

export const selectIsWebShopEnabled = createSelector(selectCompanyState, (s) => s.entity?.isWebShopEnabled);

export const selectWebShopUrl = createSelector(selectCompanyState, (s) => s.entity?.webShopUrl);
